/*!
 * enquire.js v2.1.0 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */

!function(a,b,c){var d=window.matchMedia;"undefined"!=typeof module&&module.exports?module.exports=c(d):"function"==typeof define&&define.amd?define(function(){return b[a]=c(d)}):b[a]=c(d)}("enquire",this,function(a){"use strict";function b(a,b){var c,d=0,e=a.length;for(d;e>d&&(c=b(a[d],d),c!==!1);d++);}function c(a){return"[object Array]"===Object.prototype.toString.apply(a)}function d(a){return"function"==typeof a}function e(a){this.options=a,!a.deferSetup&&this.setup()}function f(b,c){this.query=b,this.isUnconditional=c,this.handlers=[],this.mql=a(b);var d=this;this.listener=function(a){d.mql=a,d.assess()},this.mql.addListener(this.listener)}function g(){if(!a)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!a("only all").matches}return e.prototype={setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},f.prototype={addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var c=this.handlers;b(c,function(b,d){return b.equals(a)?(b.destroy(),!c.splice(d,1)):void 0})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){b(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";b(this.handlers,function(b){b[a]()})}},g.prototype={register:function(a,e,g){var h=this.queries,i=g&&this.browserIsIncapable;return h[a]||(h[a]=new f(a,i)),d(e)&&(e={match:e}),c(e)||(e=[e]),b(e,function(b){h[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},new g});
window.theme = window.theme || {};
theme.SiteNav = (function () {
    var classes = { navOpen: "nav-open", navSubOpen: "nav-sub-menu-open", imgMenuOpen: "nav-img-menu-open", subMenuActive: "site-navigation__menu-item--open", animateNav: "animate-nav" };
    var selectors = {
        nav: '[js-navigation="siteNav"]',
        navSubMenuItems: '[js-navigation="siteNavSubMenuItem"]',
        navSubMenuBtn: '[js-navigation="siteNavSubMenuBtn"]',
        navSubMenus: '[js-navigation="siteNavSubMenu"]',
        navToggle: '[js-navigation="toggleNav"]',
        navImgMenus: '[js-navigation="siteNavImgMenu"]',
        navImgBtns: '[js-navigation="siteNavImgBtn"]',
        navImgBackBtns: '[js-navigation="siteNavImgBackBtn"]',
        navImgSubMenus: '[js-navigation="siteNavImgSubMenu"]',
    };
    var cache = {},
        isTransitioning = void 0,
        mobileLimit = 480,
        wideDesktop = 1400;
    var mediaQuerySmall = "screen and (max-width: 768px)";
    function init() {
        cacheSelectors();
        cache.$navToggle.on("click", toggleNav);
        cache.$navSubMenuBtn.on("click", toggleSubMenu);
        cache.$navImgBtns.on("click", toggleImgMenu);
        enquire.register(mediaQuerySmall, {
            match: function match() {
                closeNav();
            },
            unmatch: function unmatch() {
                closeNav();
            },
        });
    }
    function cacheSelectors() {
        cache = {
            $html: $("html"),
            $body: $("body"),
            $window: $(window),
            $nav: $(selectors.nav),
            $navSubMenuItems: $(selectors.navSubMenuItems),
            $navSubMenuBtn: $(selectors.navSubMenuBtn),
            $navSubMenus: $(selectors.navSubMenus),
            $navToggle: $(selectors.navToggle),
            $navImgMenus: $(selectors.navImgMenus),
            $navImgBtns: $(selectors.navImgBtns),
            $navImgBackBtns: $(selectors.navImgBackBtns),
            $navImgSubMenus: $(selectors.navImgSubMenus),
        };
    }
    function toggleNav() {
        if (isNavOpen()) {
          //  theme.liveChat.show();
            closeNav();
        } else {
           // theme.liveChat.hide();
            openNav();
        }
    }
    function toggleImgMenu() {
        if (wideDesktopBehaviour()) return;
        var $btn = $(this),
            $parent = $btn.parent(),
         
            $menu = $btn.siblings(selectors.navImgSubMenus),
            $back = $btn.siblings(selectors.navImgBackBtns);
        $back.fadeToggle();
        $menu.slideToggle();
        $parent.siblings(selectors.navImgMenus).each(function () {
            $(this).children(selectors.navImgSubMenus).slideUp();
        });
    }
   
    function toggleSubMenu() {
        var $btn = $(this),
            $parent = $btn.parent(),
            $menuItems = cache.$navSubMenuItems.not($parent),
            $menu = $btn.siblings(selectors.navSubMenus),
            $openMenu = $("." + classes.subMenuActive).not($btn),
            $openSubMenu = $openMenu.children(selectors.navSubMenus);
        if (useMobileBehaviour()) {
            toggleMenus({
                menus: $menuItems,
                isOpen: isSubMenuopen(),
                complete: function complete() {
                    $menu.toggle();
                },
            });
        } else {
            if ($openMenu.length > 0 && !$parent.hasClass(classes.subMenuActive)) {
                $openMenu.removeClass(classes.subMenuActive);
                $openSubMenu.hide();
            }
            $menu.fadeToggle();
        }
        $parent.toggleClass(classes.subMenuActive);
        cache.$nav.toggleClass(classes.navSubOpen);
    }
    function toggleMenus(options) {
        var index = 0,
            limit = options.menus.length;
        if (options.isOpen) options.complete();
        options.menus.slideToggle(function () {
            index++;
            if (index == limit && !options.isOpen) {
                options.complete();
            }
        });
    }
    function isSubMenuopen() {
        return cache.$nav.hasClass(classes.navSubOpen);
    }
    function openNav() {
        cache.$html.addClass(classes.navOpen);
        if (useMobileBehaviour()) {
            cache.$nav.animate({ height: "toggle" }, 500, function () {
                $(this).addClass(classes.animateNav);
            });
        } else {
            cache.$nav.animate({ width: "toggle" }, 500, function () {
                $(this).addClass(classes.animateNav);
            });
        }
        $(window).on("keyup.mobileNav", function (evt) {
            if (evt.which === 27) {
                closeNav();
            }
        });
    }
    function isNavOpen() {
        return cache.$html.hasClass(classes.navOpen);
    }
    function closeNav() {
        cache.$html.removeClass(classes.navOpen);
        cache.$nav.hide();
        resetNav();
    }
    function resetNav() {
        cache.$navSubMenuItems.show().removeClass(classes.subMenuActive);
        cache.$navImgMenus.show();
        cache.$navSubMenus.hide();
        cache.$navImgBackBtns.hide();
        cache.$navImgSubMenus.hide();
        cache.$nav.removeClass(classes.navSubOpen + " " + classes.imgMenuOpen + " " + classes.animateNav);
    }
    function useMobileBehaviour() {
        return cache.$window.width() <= mobileLimit;
    }
    function wideDesktopBehaviour() {
        return cache.$window.width() >= wideDesktop;
    }
    return { init: init, closeNav: closeNav, isNavOpen: isNavOpen };
})(jQuery);
  //  theme.SiteNav.init();
   
 